import { isNull } from 'lodash';
import AbstractService from './abstractService';

// Singleton instance
let instance = null;

const _SERVICE_UNAVAILABLE_ = new Error({ message : 'Service Unavailable' });

export default class CoordinatorService extends AbstractService {
	static setup(baseURL, options) {
		instance = new CoordinatorService(baseURL, options);
	}

	static getInstance() {
		return instance;
	}

	constructor(baseURL, options) {
		super(baseURL, options);
		this.endpoint = 'organizations';
	}

	static getAll(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getAll(...params);
	}

	static getById(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getById(...params);
	}

	static getPendingInvitations() {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getPendingInvitations();
	}

	static pendingStatusChange(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._pendingStatusChange(...params);
	}

	static updateProfile(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._updateProfile(...params);
	}

	static getPosts(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getPosts(...params);
	}

	static getLocations(...params) {
		if (isNull(instance)) return Promise.reject(_SERVICE_UNAVAILABLE_);

		return instance._getLocations(...params);
	}

	_getAll(queryParams) {
		return this.get({
			endpoint : `${this.endpoint}`,
			queryParams,
		});
	}

	_getById(Id) {
		return this.get({
			endpoint : `${this.endpoint}/${Id}`,
		});
	}

	_getPendingInvitations() {
		return this.get({
			endpoint : 'clientinvitations',
		});
	}

	_pendingStatusChange(pendingInvitationItem) {
		return this.put({
			endpoint : `clientinvitations/${pendingInvitationItem.Id}`,
			data     : pendingInvitationItem,
		});
	}

	_updateProfile({
		id,
		name,
		primaryContactId,
		emergencyContactId,
		status : clientStatus,
		organizationTypeId = 0,
		biography,
		organizationLogoId,
	}) {
		const endpoint = `${this.endpoint}/${id}`;
		return this.put({
			endpoint,
			data : {
				name,
				primaryContactId,
				emergencyContactId,
				clientStatus,
				organizationTypeId,
				biography,
				organizationLogoId,
			},
		});
	}

	_getPosts({
		id,
		pagingToken,
		displayCount,
		pageNumber,
	}) {
		return this.get({
			endpoint    : `${this.endpoint}/${id}/posts`,
			queryParams : {
				pagingToken,
				displayCount,
				pageNumber,
			},
		});
	}

	_getLocations({
		id,
		displayCount,
		pageNumber,
	}) {
		return this.get({
			endpoint    : `${this.endpoint}/${id}/locations`,
			queryParams : {
				displayCount,
				pageNumber,
			},
		});
	}
}
